var _circle, _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEmotionsDisgusted = function SvgEmotionsDisgusted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#emotions-disgusted_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.167 7.5c0-.46.373-.833.833-.833h2.5a.833.833 0 0 1 0 1.666H5a.833.833 0 0 1-.833-.833Zm2.5 7.5a3.333 3.333 0 0 1 6.666 0H6.667ZM12.5 6.667a.833.833 0 0 0 0 1.666H15a.833.833 0 1 0 0-1.666h-2.5Z",
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "emotions-disgusted_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90 2.708 7.292) scale(15.4167)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#98E791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C9845"
  })))));
};

export default SvgEmotionsDisgusted;